import { Component } from '@ecs/Component';

export class AimTelegraph implements Component {
  readonly type = 'AimTelegraph';

  constructor(
    public active: boolean = false,
    public angle: number = 0,
    public length: number = 300,
    public progress: number = 0,
    public color: string = '#ff00ff'
  ) {}
}
